import { render, staticRenderFns } from "./SendDocumentTemplateTable.vue?vue&type=template&id=64787315&scoped=true&lang=pug"
import script from "./SendDocumentTemplateTable.vue?vue&type=script&lang=ts"
export * from "./SendDocumentTemplateTable.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentTemplateTable.vue?vue&type=style&index=0&id=64787315&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64787315",
  null
  
)

export default component.exports